// utils/geolocation.js
// One-shot geolocation helper for "use my current location" actions.
// The useGeolocation hook is a continuous watchPosition (built for the camera);
// for a button press we want a single high-accuracy fix.

/**
 * Get the device's current position once.
 * @param {Object} [options]
 * @param {boolean} [options.enableHighAccuracy=true]
 * @param {number} [options.timeout=15000] ms before rejecting
 * @param {number} [options.maximumAge=0] ms a cached position may be reused
 * @returns {Promise<{latitude: number, longitude: number, accuracy: number}>}
 * @throws {Error} if geolocation is unsupported or the user denies/times out
 */
export const getCurrentPositionOnce = ({
  enableHighAccuracy = true,
  timeout = 15000,
  maximumAge = 0,
} = {}) =>
  new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("Geolocation is not supported on this device."));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) =>
        resolve({
          latitude: pos.coords.latitude,
          longitude: pos.coords.longitude,
          accuracy: pos.coords.accuracy,
        }),
      (err) => reject(err),
      { enableHighAccuracy, timeout, maximumAge }
    );
  });
